import { headerNav } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-2xl text-primary-400 tracking-wide">
              女神漫画
            </span>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              女神漫画是国内领先的在线漫画阅读与推荐平台，专注韩漫、日漫、国漫热门推荐，提供排行榜精选、免费全集下拉式阅读，并支持追更与收藏，尽享漫画大全。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#hero" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">首页</a>
              </li>
              {headerNav.map((item) => (
                <li key={item.anchor}>
                  <a href={item.anchor} className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">{item.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">韩漫推荐</a></li>
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">日漫经典</a></li>
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">国漫精选</a></li>
              <li><a href="#index" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">完结神作</a></li>
              <li><a href="#updates" className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer">最新更新</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              我们与多家知名漫画版权方和创作平台保持深度合作，持续为读者带来优质正版漫画内容。
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              <span className="px-3 py-1.5 text-xs rounded-full bg-background-800 text-background-300">漫画出版社</span>
              <span className="px-3 py-1.5 text-xs rounded-full bg-background-800 text-background-300">创作平台</span>
              <span className="px-3 py-1.5 text-xs rounded-full bg-background-800 text-background-300">版权代理</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; 2026 女神漫画 · 韩漫日漫国漫全集免费推荐平台。保留所有权利。
          </p>
          <div className="flex items-center gap-4 text-background-400">
            <span className="text-xs cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="text-xs cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="text-xs cursor-pointer hover:text-primary-400 transition-colors">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}